import type { SnapshotManifest, SnapshotManifestFile } from '@cli-types/core-engine/snapshots.js'

export function manifestFilesByPath(manifest: SnapshotManifest): Map<string, SnapshotManifestFile> {
  return new Map(manifest.files.map((file) => [file.path, file]))
}
